// extracted by mini-css-extract-plugin
export default {"root":"IconAdd_root__KFggO"};